/**
 * @generated SignedSource<<912dcc034d3241ebffdff6439a6e10ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CommonProviderCityDicQuery$variables = Record<PropertyKey, never>;
export type CommonProviderCityDicQuery$data = {
  readonly citydistrict_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly city: string;
        readonly district: ReadonlyArray<string>;
        readonly id: string;
      };
    }>;
  };
};
export type CommonProviderCityDicQuery = {
  response: CommonProviderCityDicQuery$data;
  variables: CommonProviderCityDicQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "citydistrictConnection",
    "kind": "LinkedField",
    "name": "citydistrict_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "citydistrictEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "citydistrict",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "district",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommonProviderCityDicQuery",
    "selections": (v0/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CommonProviderCityDicQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c457a615b68e3e7a7f09d07973f3dd9a",
    "id": null,
    "metadata": {},
    "name": "CommonProviderCityDicQuery",
    "operationKind": "query",
    "text": "query CommonProviderCityDicQuery {\n  citydistrict_connection {\n    edges {\n      node {\n        city\n        district\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2def22cb2e412730b12dc281a9a5257d";

export default node;
